import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="min-h-screen w-full overflow-x-hidden" data-id="element-130">
      <HeroSection data-id="element-131" />
      <ProblemSection data-id="element-132" />
      <SolutionSection data-id="element-133" />
      <FeaturesSection data-id="element-134" />
      <PricingSection data-id="element-135" />
      <Footer data-id="element-136" />
    </main>;
}